<template>
    <v-container fluid id="widget-applications-frame" class="widget-applications widget-component">
        <v-container>
            <main-menu
                v-if="normalizedOptions.menu.show"
                :root-url="rootUrl"
                :loginDialog="loginDialog"
                :accessToken="accessToken"
                :show-login-if-logged-out="true"
                @loggedIn="handleLoginEmit"
                :show-elements="normalizedOptions.menu.show"
                @showLoginDialog="handleLoginDialogEmit"
            >
            </main-menu>
            <v-row v-if="normalizedOptions.title.show">
                <v-col cols="12">
                    <h1 class="mb-4">
                        {{ normalizedOptions.title.text }}
                    </h1>
                </v-col>
            </v-row>
            <v-row v-if="loading" v-for="index in 3" :key="index">
                <v-col cols="12">
                    <v-row>
                        <v-col cols="3">
                            <v-skeleton-loader type="image"></v-skeleton-loader>
                        </v-col>
                        <v-col cols="7">
                            <v-row>
                                <v-col cols="8" class="pb-2">
                                    <v-skeleton-loader class="pb-0 pt-0" type="card-heading"></v-skeleton-loader>
                                </v-col>
                                <v-col cols="4" class="pb-2 text-right">
                                    <div class="vd-inline-block mr-3">
                                        <v-icon class="pr-2">mdi-bed-king-outline</v-icon>
                                    </div>
                                    <div class="vd-inline-block">
                                        <v-icon class="pr-2">mdi-shower</v-icon>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-skeleton-loader class="pb-0 pt-0" type="paragraph"></v-skeleton-loader>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-skeleton-loader class="pb-0 pt-0" type="paragraph"></v-skeleton-loader>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row v-if="applications.length == 0">
                <v-col>
                    <v-alert type="info" class="mb-10">
                        You currently do not have any active applications.
                    </v-alert>
                </v-col>
            </v-row>

            <v-row v-if="archiveSuccessful">
                <v-col>
                    <v-alert type="success" class="mb-10">
                        Application archived successfully
                    </v-alert>
                </v-col>
            </v-row>

            <v-row v-for="(application) in applications" :key="application.id" class="mb-6">
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12" md="3">
                            <a :href="generateURL(application.listing)">
                                <v-img
                                    max-height="250"
                                    contain
                                    class="border-4-solid-F5F4F1"
                                    :src="application.listing.mainImage.thumbnail"
                                ></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-row>
                                <v-col cols="12" sm="7" class="pb-2">
                                    <a class="text-decoration-none" :href="generateURL(application.listing)">
                                        <v-card-title class="pb-0 pt-0 pl-0">
                                            {{ application.listing.name }}
                                        </v-card-title>
                                    </a>
                                </v-col>
                                <v-col cols="12" sm="5" class="pb-2 text-right">
                                    <div class="vd-inline-block mr-3">
                                        <v-icon class="pr-2">mdi-bed-king-outline</v-icon>
                                        <span class="fs-0875">
                                                    {{ application.listing.bedroomsFormatted }}
                                                </span>
                                    </div>
                                    <div class="vd-inline-block">
                                        <v-icon class="pr-2">mdi-shower</v-icon>
                                        <span class="fs-0875">
                                                    {{ application.listing.bathroomsFormatted }}
                                                </span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-card-text class="pt-0 pb-0 pl-0">{{
                                            application.listing.displayAddress
                                        }}
                                    </v-card-text>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-2">
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row v-if="!application.listing.forSale">
                                <v-col cols="7" class="pt-0 pb-1">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030 opacity-07">
                                        Weekly rent
                                    </v-card-text>
                                </v-col>
                                <v-col cols="5" class="pt-0 pb-1 text-right">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030 opacity-07"
                                                 v-if="application.listing.weeklyRent && application.listing.availabilityStatus.code == 'available'">
                                        {{ currencyFormatter.format(application.listing.weeklyRent) }}
                                    </v-card-text>
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030 opacity-07" v-else>
                                        TBC
                                    </v-card-text>
                                </v-col>
                            </v-row>
                            <v-row v-if="application.listing.forSale">
                                <v-col cols="7" class="pt-0 pb-1">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030 opacity-07">
                                        Minimum deposit
                                    </v-card-text>
                                </v-col>
                                <v-col cols="5" class="pt-0 pb-1 text-right">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030 opacity-07"
                                                 v-if="application.listing.depositValue && application.listing.availabilityStatus.code == 'available'">
                                        {{ currencyFormatter.format(application.listing.depositValue) }}
                                    </v-card-text>
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030 opacity-07" v-else>
                                        TBC
                                    </v-card-text>
                                </v-col>
                            </v-row>
                            <v-row v-if="!application.listing.forSale">
                                <v-col cols="7" class="pt-0 pb-1">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030">
                                        <strong>Monthly Rent</strong>
                                    </v-card-text>
                                </v-col>
                                <v-col cols="5" class="pt-0 pb-1 text-right">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030"
                                                 v-if="application.listing.monthlyRent && application.listing.availabilityStatus.code == 'available'">
                                        <strong>
                                            {{ currencyFormatter.format(application.listing.monthlyRent) }}
                                        </strong>
                                    </v-card-text>
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030" v-else>
                                        <strong>-</strong>
                                    </v-card-text>
                                </v-col>
                            </v-row>
                            <v-row v-if="application.listing.isSharedOwnership">
                                <v-col cols="7" class="pt-0 pb-1">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030 opacity-07">
                                        {{ application.listing.minSharePercentage }}%
                                        Share from
                                    </v-card-text>
                                </v-col>
                                <v-col cols="5" class="pt-0 pb-1 text-right">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030 opacity-07"
                                                 v-if="application.listing.minShareValue && application.listing.availabilityStatus.code == 'available'">
                                        {{ currencyFormatter.format(application.listing.minShareValue) }}
                                    </v-card-text>
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030 opacity-07" v-else>
                                        TBC
                                    </v-card-text>
                                </v-col>
                            </v-row>
                            <v-row v-if="application.listing.forSale">
                                <v-col cols="7" class="pt-0 pb-1">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030">
                                        <strong>Full price</strong>
                                    </v-card-text>
                                </v-col>
                                <v-col cols="5" class="pt-0 pb-1 text-right">
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030"
                                                 v-if="application.listing.fullMarketPrice && application.listing.availabilityStatus.code == 'available'">
                                        <strong>
                                            {{ currencyFormatter.format(application.listing.fullMarketPrice) }}
                                        </strong>
                                    </v-card-text>
                                    <v-card-text class="pt-0 pb-0 pl-0 color-303030" v-else>
                                        <strong>TBC</strong>
                                    </v-card-text>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-1">
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row v-if="normalizedOptions.applicationForm.enabled">
                                <v-col v-if="application.assessments.length">
                                    <v-row v-if="application.assessments.length">
                                        <v-col cols="12" class="pt-4 pb-1" v-for="assessment in application.assessments"
                                               :key="assessment.id">
                                            <v-btn small color="secondary" v-if="assessment.status == 'draft'"
                                                   @click="editApplicationForm(assessment)">
                                                Continue application form
                                            </v-btn>
                                            <v-btn small color="secondary" v-else-if="assessment.status == 'submitted'"
                                                   @click="viewApplicationForm(assessment)">
                                                View submitted application form
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-else>
                                    <v-row>
                                        <v-col cols="12" class="pt-4 pb-1">
                                            <v-btn small color="primary" @click="startApplicationForm(application)">
                                                Start application process
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-if="application.listing.openDays.length > 0">
                                    <v-row>
                                        <v-col class="pt-4 pb-1">
                                            <v-btn
                                                color="primary"
                                                dark
                                                small
                                                :elevation="0"
                                                @click="startBookViewing(application.listing)"
                                                v-if="!application.nextAppointmentDateTime"
                                            >
                                                Book viewing
                                            </v-btn>
                                            <v-btn
                                                color="secondary"
                                                dark
                                                small
                                                :elevation="0"
                                                @click="goToViewings"
                                                v-else
                                            >
                                                Viewing Booked
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col>
                                    <v-row>
                                        <v-col class="pt-4 pb-1">
                                            <v-tooltip top v-if="application.upcomingAppointments && application.upcomingAppointments.length > 0">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        class="v-btn--unavailable"
                                                        color="secondary"
                                                        dark
                                                        small
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :elevation="0"
                                                        >
                                                        Archive
                                                    </v-btn>
                                                </template>
                                                <span class="text-white small">You have upcoming viewings for this listing</span>
                                            </v-tooltip>

                                            <v-dialog v-else
                                                v-model="confirmArchive[application.id]"
                                                width="500"
                                                >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        color="secondary"
                                                        dark
                                                        small
                                                        v-bind="attrs"
                                                        v-on="on">
                                                        Delete
                                                    </v-btn>
                                                </template>

                                                <v-card>
                                                    <v-card-title class="text-h5 grey lighten-2">
                                                       Are you sure?
                                                    </v-card-title>

                                                    <v-card-text class="mt-5 pb-0">
                                                        I understand that deleting this application is permanent, and I
                                                        will lose all access to it, including notifications and any
                                                        related information. It's not possible to undo this action.
                                                    </v-card-text>

                                                    <v-divider class="pb-0 mb-0"></v-divider>

                                                    <v-card-actions class="justify-content-between">
                                                        <v-btn
                                                        color="primary"
                                                        text
                                                        @click="$set(confirmArchive, application.id, false)"
                                                        >
                                                            Cancel
                                                        </v-btn>

                                                        <v-btn
                                                            color="primary"
                                                            @click="archive(application)"
                                                        >
                                                            Confirm
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="px-0">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-dialog
                v-model="showPrivateOpenDayCodeWindow"
                width="500"
                persistent
            >
                <v-card class="widget-component">
                    <v-card-title class="text-h5 grey lighten-2">
                        Book a viewing
                    </v-card-title>

                    <v-card-text class="mt-5 pb-0">
                        To continue, please enter the appointment code you have been given
                        <v-row class="mt-4">
                            <v-col>
                                <v-text-field
                                    id="codeField"
                                    label="Appointment code *"
                                    v-model="bookingCode"
                                    hide-details="auto"
                                    class="rounded-0 mb-4"
                                    :error="hasCodeError"
                                    :error-messages="codeErrorMessage"
                                    outlined
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider class="pb-0 mb-0"></v-divider>

                    <v-card-actions class="justify-content-between">
                        <v-btn
                            color="primary"
                            text
                            @click="closePrivateOpenDayCodeWindow"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            color="primary"
                            @click="checkBookingCode"
                        >
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="showBookingWindow"
                width="700"
            >
                <v-card class="widget-component">
                    <v-card-title class="text-h5 grey lighten-2">
                        Book a viewing
                    </v-card-title>

                    <v-card-text class="mt-5 pa-8">
                        <booking-form
                            v-if="listing"
                            :modal="false"
                            inline
                            :listing-id="listing.id"
                            :listing-name="listing.name"
                            :listing-location="listing.displayAddress"
                            :logged-in-profile="loggedInProfile"
                            :booking-code="bookingCode"
                            :skip-form-step="isFormStepSkippable()"
                            :show-finish-button="true"
                            @refreshBooking="finishedBooking"
                            :key="bookingFormKey"
                        ></booking-form>
                    </v-card-text>

                </v-card>
            </v-dialog>
        </v-container>
    </v-container>
</template>

<script>
import {defineComponent, ref, onMounted, computed} from '@vue/composition-api';
import {has, merge} from "lodash";
import MainMenu from "./partials/MainMenu";
import ProfileService from "../services/ProfileService";
import ListingService from "../services/ListingService";

export default defineComponent({
    name: 'Applications',
    components: {MainMenu},
    props: {
        rootUrl: {
            type: String,
            required: true
        },
        accessToken: {
            type: String,
        },
        settings: {
            type: Object
        },
        listingsUrl: {
            type: String,
            default: null
        },
    },
    setup(props, context) {
        const loading = ref(false);
        const confirmArchive = ref([]);
        const archiveSuccessful = ref(false);
        const applications = ref([]);
        const loggedInProfile = ref(false);
        const loggedIn = ref(false);

        const token = ref(null);
        const loginDialog = ref(false);
        const activeTab = ref('applications');

        // Private open day related variables
        const listing = ref(null);
        const showPrivateOpenDayCodeWindow = ref(false);
        const bookingCode = ref(null);
        const hasCodeError = ref(false);
        const codeErrorMessage = ref("");
        const showBookingWindow = ref(false);
        const bookingFormKey = ref(0);
        const validBookingCode = ref(false);

        const currencyFormatter = new Intl.NumberFormat('gb-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        const defaultSettings = ref({
            enabled: true,
            title: {
                show: true,
                text: 'Applications',
            },
            menu: {
                show: false
            },
            applicationForm: {
                enabled: false,
                urls: {
                    view: '/application-form/view/{id}',
                    edit: '/application-form/edit/{id}',
                    start: '/application-form/{slug}',
                }
            },
            events: {
                redirectIfNotLoggedIn: '/login',
            }
        });

        const normalizedOptions = computed(() => {
            return merge(defaultSettings.value, props.settings);
        });

        function getApplications() {
            loading.value = true;
            ProfileService.getApplications().then((response) => {
                if (has(response, 'data.data')) {
                    response.data.data.forEach((application) => {
                        if(!application.isArchived){
                            applications.value.push(application);
                            confirmArchive.value[application.id] = false;
                        }
                    })
                }
            })
            .catch(error => {
                if (has(error, 'response.data')) {
                    errors.value = error.response.data;
                }
            })
            .finally(() => {
                loading.value = false;

                setTimeout(function(){
                    archiveSuccessful.value = false;
                }, 3000);
            });
        }

        function generateURL(listing) {
            const listingSlug = has(listing, 'widgetSiteSettings.customSlug') && listing.widgetSiteSettings.customSlug ?
                listing.widgetSiteSettings.customSlug : listing.slug;

            return props.listingsUrl ? props.listingsUrl.replace("{slug}", listingSlug) :
                props.rootUrl + '/listing/' + listingSlug;
        }

        function handleLoginEmit(data) {
            if (data.loggedInProfile) {
                loggedInProfile.value = data.loggedInProfile;
            }
            if (data.accessToken) {
                token.value = data.accessToken;
            }
            getApplications();
        }

        function handleLoginDialogEmit(val) {
            loginDialog.value = val;
        }

        function redirectToLogin() {
            if (has(normalizedOptions.value, 'events.redirectIfNotLoggedIn')) {
                window.location.href = normalizedOptions.value.events.redirectIfNotLoggedIn;
            }
        }

        function startApplicationForm(application) {
            if (has(normalizedOptions.value, 'applicationForm.urls.start') && has(application, 'listing.slug')) {
                const url = normalizedOptions.value.applicationForm.urls.start.replace("{slug}", application.listing.slug);
                window.location.href = url;
            }
        }

        function archive(application) {
            confirmArchive.value[application.id] = false;
            loading.value = true;

            ProfileService.archiveApplication(application.id).then((response) => {
                archiveSuccessful.value = true;
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                applications.value = [];
                getApplications();
            });
        }

        function editApplicationForm(applicationAssessment) {
            if (has(normalizedOptions.value, 'applicationForm.urls.edit') && has(applicationAssessment, 'id')) {
                const url = normalizedOptions.value.applicationForm.urls.edit.replace("{id}", applicationAssessment.id);
                window.location.href = url;
            }
        }

        function viewApplicationForm(applicationAssessment) {
            if (has(normalizedOptions.value, 'applicationForm.urls.view') && has(applicationAssessment, 'id')) {
                const url = normalizedOptions.value.applicationForm.urls.view.replace("{id}", applicationAssessment.id);
                window.location.href = url;
            }
        }

        function closePrivateOpenDayCodeWindow() {
            showPrivateOpenDayCodeWindow.value = false;
            hasCodeError.value = false;
            codeErrorMessage.value = "";
            bookingCode.value = null;
            listing.value = null;
        }

        function startBookViewing(listingToBook) {
            listing.value = listingToBook;
            if(has(listing.value, 'enablePrivateOpenDays')) {
                if(listing.value.enablePrivateOpenDays === true) {
                    // Open modal for getting the booking code
                    showPrivateOpenDayCodeWindow.value = true;
                } else {
                    showBookingWindow.value = true;
                }
            } else {
                // Open booking process modal
                showBookingWindow.value = true;
            }
        }

        function checkBookingCode() {
            validBookingCode.value = false;
            hasCodeError.value = false;
            codeErrorMessage.value = "";
            ListingService.checkBookingCode(listing.value.id, bookingCode.value).then((response) => {
                if(has(response, 'data.success')) {
                    if(response.data.success === true) {
                        showBookingWindow.value = true;
                        validBookingCode.value = true;
                    } else {
                        // show generic error
                        hasCodeError.value = true;
                        codeErrorMessage.value = 'An error occurred while checking the booking code. Please try again later';
                    }
                }
            })
            .catch(error => {
                hasCodeError.value = true;
                if(has(error, 'response.data.message')) {
                    codeErrorMessage.value = error.response.data.message;
                } else {
                    codeErrorMessage.value = error.message;
                }
            });
        }

        function goToViewings() {
            context.emit('changeTab','viewings');
        }

        function isFormStepSkippable() {
            if(
                has(loggedInProfile.value, 'firstName') &&
                has(loggedInProfile.value, 'lastName') &&
                has(loggedInProfile.value, 'email') &&
                has(loggedInProfile.value, 'phone') &&
                has(listing.value, 'enablePrivateOpenDays')
            ) {
                if(
                    loggedInProfile.value.firstName.length > 0 &&
                    loggedInProfile.value.lastName.length > 0 &&
                    loggedInProfile.value.email.length > 0 &&
                    loggedInProfile.value.phone.length > 0 &&
                    (listing.value.enablePrivateOpenDays === false || (listing.value.enablePrivateOpenDays === true && validBookingCode.value === true))
                ) {
                    return true
                }
            }
            return false;
        }

        function finishedBooking() {
            showBookingWindow.value = false;
            closePrivateOpenDayCodeWindow();
            context.emit('update');
        }

        function init() {
            loggedIn.value = false;
            ProfileService.getProfile()
                .then(response => {
                    loggedIn.value = true;
                    loggedInProfile.value = response;
                    getApplications();
                })
                .catch(error => {
                    loggedIn.value = false;
                    redirectToLogin();
                });
        }

        onMounted(() => {
            init();
        });

        return {
            // Variables
            token,
            loading,
            applications,
            loginDialog,
            loggedInProfile,
            activeTab,
            currencyFormatter,
            normalizedOptions,
            confirmArchive,
            archiveSuccessful,
            showPrivateOpenDayCodeWindow,
            bookingCode,
            hasCodeError,
            codeErrorMessage,
            showBookingWindow,
            listing,
            bookingFormKey,
            // Functions
            has,
            generateURL,
            handleLoginEmit,
            handleLoginDialogEmit,
            editApplicationForm,
            viewApplicationForm,
            startApplicationForm,
            archive,
            startBookViewing,
            checkBookingCode,
            closePrivateOpenDayCodeWindow,
            goToViewings,
            isFormStepSkippable,
            finishedBooking
        }

    }
});

</script>

<style lang="scss">
    .widget-applications{
        .v-btn{
            width: 100%;
            text-transform: none;
            letter-spacing: normal;
        }

        .v-btn.v-btn--unavailable{
            cursor: not-allowed;
            color: var(--v-secondary-base) !important;
            background-color: rgba(0,0,0,0.2) !important;
            opacity: 0.6;
        }
    }
</style>
